import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Button } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import AllVendorsTable from "./PurchaseTables/AllVendorsTable";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import PurchasePayment from "../../modals/purchasePaymentModal";
import plus from "../../assets/Images/plus.svg";
import AddVendor from "./AddVendor";
import { checkPermission } from "../../Utils/permissionHelper";

const AllVendors = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(true);

  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [popup, setpopup] = useState(false);
  const [vendorID, setVendorId] = useState(null);
  const [showComponent, setShowComponent] = useState(false);
  const [editData, setEditData] = useState(null);

  const getAllVendors = (text, currentLimit, currentOffset) => {
    fetchAllVendors(user_id, currentLimit, currentOffset, text).then(
      (datagot) => {
        setloading(false);
        setData(datagot);
      }
    );
  };

  const refreshVendorData = () => {
    getAllVendors(query, currentLimit, currentOffset);
  };

  const debouncedSearch = debounce((value) => {
    setloading(true);
    getAllVendors(value, 15, 0);
  }, 1200);

  const handlePaymentClick = (val) => {
    if (!checkPermission("/purchase/vendors")) {
      // toast.error("You do not have permission to perform this action.");
      return;
    }
    console.log("VADVSVDVSD", val);
    setVendorId(val?.id);
    setIsModalVisible(true);
  };

  const closeAddVendor = () => {
    setShowComponent(false);
    refreshVendorData();
                  setEditData(null)

  };


  const onEditLine =async(data)=>{
    setShowComponent(true);
    setEditData(data)
  }

  return (
    <>
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#F6F7F9]">
        <Navbar heading="Vendor List" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden">
          <div className="font-extrabold mb-3 mx-5">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={
                showComponent
                  ? [
                    {
                      title: (
                        <span
                          className="cursor-pointer  hover:bg-gray-200 hover:text-black"
                          onClick={() => {
                             setEditData(null);
                            setShowComponent(false)}}
                        >
                          {t("Vendor List")}
                        </span>
                      ),
                      key: "all-vendors",
                    },
                    { title: t("Add Vendor"), key: "add-vendor" },
                  ]
                  : [
                    // {
                    //   title: <Link to={routes.purchase}>{t("Purchase")}</Link>,
                    //   key: "purchase",
                    // },
                    // { title: t("Vendor Payment"), key: "all-vendors" },
                  ]
              }
              className="relative mt-3 font-semibold"
            />
          </div>

          {/* Only show the search bar if showComponent is false */}
          <div className="flex justify-between me-4 mx-5">
            {!showComponent && (
              <SearchBox
                searchResult={(values) => {
                  setquery(values)
                  debouncedSearch(values)}}
                placeholder={t("Search Vendors")}
                value={query}
              />
            )}

            {/* Only show the "Add New Vendor" button if showComponent is false */}
            {!showComponent && (
              <button
                // onClick={() => setShowComponent(true)}
                onClick={() => {
                  if (checkPermission("/purchase/vendors")) {
                    setShowComponent(true);
                  }
                }}
                className="font-semibold w-48 h-10 border rounded-lg bg-primaryBlue text-white text-base flex justify-center items-center gap-2"
                type="submit"
              >
                <img src={plus} alt="plus" />
                <p>{t("Add New Vendor")}</p>
              </button>
            )}
          </div>

          {/* Show loading shimmer or vendor data */}

          {/* Only show the table if showComponent is false */}
          {!showComponent && (
            <div className="mt-3 mx-5">
              <AllVendorsTable
                loading={loading}
                additionalData={data}
                pagination={(values) => {
                  console.log("ALl vendors");
                  setCurrentLimit(values.limit);
                  setCurrentOffset(values.offset);
                  getAllVendors(query, values.limit, values.offset);
                }}
                handlePaymentClick={handlePaymentClick}
                onEditLine={onEditLine}
              />
            </div>
          )}

          {/* Show the Add Vendor component if showComponent is true */}
          {showComponent && (
            <div className="mt-3 me-4">
              <AddVendor
                onClose={() => {
                  closeAddVendor();
                }}
                editData={editData}
                isEdit={editData ? true : false}
              />
            </div>
          )}

          {/* Payment Modal */}
          {isModalVisible && (
            <PurchasePayment
              isOpen={isModalVisible}
              onClose={() => setIsModalVisible(false)}
              vendor_id={vendorID}
              page={"allVendors"}
              Popup={() => setpopup(true)}
              onPaymentSuccess={refreshVendorData}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AllVendors;
